export const generateTransactionBannerScript = (locale = 'en-gb') => `
  var bookingTransactionCookieValue = '',
      closeTransactionBannerDesktop,
      closeTransactionBannerMobile;

  var bookingTransactionDescription =
    '${locale}' === 'fr-fr'
      ? 'Finalisez votre réservation en quelques clics.'
      : 'Pick up where you left off and complete your booking in just a few taps.';

  var bookingTransactionCtaText =
    '${locale}' === 'fr-fr' ? 'Continuer' : 'Continue booking';

  function getCookies(allCookie) {
      var cookies = {};
      allCookie.split("; ").forEach(function (el) {
          var [key, value] = el.split("=");
          cookies[key] = value;
      });
      return cookies;
  }

  function setCookie(cookieName, cookieValue, nDays) {
      var expire = new Date();
      expire.setTime(Date.now() + nDays * 24 * 3600000);
      document.cookie = \`\${cookieName}=\${cookieValue}; expires=\${expire.toGMTString()}; domain=\${window.location.hostname}; path=/\`;
  }

  var showTransactionBanner = function ($data) {
      var bannerInfo = JSON.parse($data);
      var bannerWrap = document.getElementById('transaction-banner-section');
      if (bannerWrap) {
          var html = \`
                    <div class="transaction-banner-inner-wrap">
        <div class="transaction-banner">
          <div class="banner-elements">
            <div class="banner-text-container">
              <span class="banner-text-title">\${bannerInfo.service.title}</span>
              <span class="banner-text-description">
                \${bookingTransactionDescription}
              </span>
            </div>
            <div class="banner-actions-container">
              <button
                class="primary-btn desktop-btn"
                data-book-btn="true"
                data-booking-transaction-id="\${bannerInfo.id}"
              >
                \${bookingTransactionCtaText}
              </button>
              <div class="close-transaction-banner-desktop" id="close-transaction-banner-desktop"></div>
            </div>
          </div>
          <div class="close-transaction-banner-mobile" id="close-transaction-banner-mobile"></div>
        </div>
      </div>\`;

          bannerWrap.innerHTML = html;
          bannerWrap.classList.add('show');

          closeTransactionBannerDesktop = document.getElementById('close-transaction-banner-desktop');
          closeTransactionBannerMobile = document.getElementById('close-transaction-banner-mobile');

          closeTransactionBannerDesktop.addEventListener('click', hideTransactionBanner);
          closeTransactionBannerMobile.addEventListener('click', hideTransactionBanner);
      }
  };

  var hideTransactionBanner = function () {
      document.cookie = \`bookingTransaction=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=\${window.location.hostname}\`;
      var bannerWrap = document.getElementById('transaction-banner-section');
      if (bannerWrap) {
          bannerWrap.classList.remove('show');
          setTimeout(() => bannerWrap.innerHTML = '', 500);
      }
  };

  document.addEventListener("DOMContentLoaded", function () {
      document.addEventListener("bookingTransaction", function (e) {
          if (e.detail.data.state === 'new' || e.detail.data.state === 'restore') {
              bookingTransactionCookieValue = JSON.stringify(e.detail.data);
          } else if (e.detail.data.state === 'complete') {
              bookingTransactionCookieValue = '';
              hideTransactionBanner();
          }
      });

      if (getCookies(document.cookie)['bookingTransaction'] !== undefined) {
          showTransactionBanner(getCookies(document.cookie)['bookingTransaction']);
      }

      document.addEventListener("obf-status", function (e) {
          if (e.detail.message === 'close') {
              if (!bookingTransactionCookieValue) {
                  hideTransactionBanner();
              } else {
                  setCookie('bookingTransaction', bookingTransactionCookieValue, 7);
                  showTransactionBanner(bookingTransactionCookieValue);
              }
          }
      });
  });
`;
